import UserToken from '@admin/tokens/user'
import Form from '@admin/components/form'
import PropTypes from 'prop-types'
import React from 'react'

class Sidebar extends React.Component {

  static contextTypes = {
    modal: PropTypes.object,
    network: PropTypes.object
  }

  static propTypes = {
    announcement: PropTypes.object,
    dirty: PropTypes.bool,
    onChange: PropTypes.func,
    onSave: PropTypes.func
  }

  formRef = React.createRef()

  _handleSubmit = this._handleSubmit.bind(this)
  _handleSuccess = this._handleSuccess.bind(this)

  render() {
    return (
      <div className="maha-announcement-designer-sidebar">
        <Form { ...this._getForm() } />
      </div>
    )
  }

  _getForm() {
    const { announcement, dirty, onChange, onSave } = this.props
    return {
      ref: this.formRef,
      showHeader: false,
      onChange,
      onSuccess: this._handleSuccess,
      ...onSave ? {
        buttons: [
          { 
            label: 't(Save)', 
            color: 'blue', 
            disabled: !dirty, 
            handler: this._handleSubmit 
          }
        ]
      } : {},
      sections: [
        {
          fields: [
            { 
              label: 't(Author)', 
              name: 'author.user',
              type: 'lookup',
              endpoint: '/api/admin/users',
              filter: {
                is_active: {
                  $eq: true
                }
              },
              valueKey: null,
              compareKey: 'id',
              textKey: 'full_name',
              format: UserToken,
              value: announcement.author?.user
            },
            { 
              label: 't(Carousel)', 
              name: 'images', 
              type: 'mediafield',
              ratio: 5/3,
              multiple: true,
              value: announcement.images
            },
            { 
              label: 't(Body)', 
              name: 'body', 
              type: 'htmlfield', 
              required: true,
              value: announcement.body
            },
            { 
              label: 't(Call to Action)',
              type: 'segment',
              fields: [
                { 
                  type: 'radiogroup',
                  name: 'cta.show',
                  options: [
                    { value: false, text: 't(Do not show button)' },
                    { value: true, text: 't(Show button)' }
                  ],
                  value: announcement.cta?.show === true
                },
                { 
                  label: 't(Button Text)', 
                  name: 'cta.text', 
                  type: 'textfied', 
                  required: true,
                  show: announcement.cta?.show === true,
                  value: announcement.cta?.text
                },
                { 
                  label: 't(Link To)',
                  placeholder: 't(Enter URL)',
                  name: 'cta.url', 
                  type: 'urlfield', 
                  required: true,
                  show: announcement.cta?.show === true,
                  value: announcement.cta?.url
                }
              ]
            }
          ]
        }
      ]
    }
  }

  _handleSubmit() {
    this.formRef.current.submit()
  }

  _handleSuccess(announcement) {
    this.props.onSave(announcement)
  }

}

export default Sidebar
